import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/auth-guard'
import CompleteProfilePage from '@/pages/CompleteProfile'

export const Route = createFileRoute('/complete-profile')({
  ...requireAuth(),
  component: CompleteProfilePage,
})
